<template>
  <div>
    <div class="list">
       <!--一条数据开始-->
       <template v-if="list.length">
        <div class="listItem" v-for="item in list" :key="item.id">
            <div class="pageTitle">
                  <span class="name">{{item.applicationName}}</span>
                  <template v-if="item.status === 0">
                    <span class="status status0">审核中</span>
                  </template>
                  <template v-if="item.status === 1">
                    <span class="status status1">通过</span>
                  </template>
                  <template v-if="item.status === 2">
                    <span class="status status2">不通过</span>
                  </template>
                  <template v-if="item.status == 1">

                    <div class="btn">
                      <a :href="item.loginUrl" target="_blank">
                      <div>跳转应用</div>
                      <img src="../../../assets/images/rightArrow.png" alt="">
                      </a>
                    </div>
                    <div style="bottom: 70px" class="btn btn1" @click="handleRegister(item)">
                      <div>同步账号</div>
                    </div>
                  </template>

            </div>
            <div class="pageContent">
                  <div>
                    <span class="label">审核时间</span>
                    <span>{{item.approveTime}}</span>
                  </div>

              </div>
              <div class="pageContent">
                  <div class="ts">
                    <span class="label">应用描述</span>
                    <span>{{item.describe}}</span>
                  </div>
              </div>

        </div>
       </template>
       <template v-else>
         <div class="noData">
            <img src="../../../assets/images/zwsj@2x.png" />
            <div>暂无数据</div>
          </div>
       </template>

    </div>
    <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageNum"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next"
    :total="total">
    </el-pagination>
    <RegisterDialog ref="registerDialog" @refresh="getList" />
  </div>
</template>
<script>
import { fetchMyApp } from '@/api/api'
import RegisterDialog from './RegisterDialog'
export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        list: [],
        loading: false,
      }
    },
    created() {
        this.getList()
    },
    components:{
      RegisterDialog
    },
    methods:{
      handleRegister(item) {
        let data = {
          type: 1,
          applicationId: item.applicationId
        }
        this.$refs.registerDialog.openDialog(data)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      getList() {
        let params = {
          page: this.pageNum >= 1 ?this.pageNum - 1 : 0,
          size: this.pageSize
        }
        fetchMyApp(params).then(res => {
          this.list = res.data.content
          console.log(this.list)
          this.total = Number(res.data.totalElements)
        })
      }
    }
}
</script>
<style scoped>
  .listItem {
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }

  .pageTitle {
    padding: 15px 0;
  }

  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 30%;
  }
  .pageContent > div.ts{
      width: 85%;
  }
  .pageContent .label{
      color: rgba(144, 157, 177, 1);
      padding-right: 20px;
      min-width: 80px;
      padding-right: 20px;
  }

  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
    /* border: 1PX SOLID #F00; */
  }
  .list::-webkit-scrollbar { width: 0 !important }

      .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 20px;
    bottom: 10px;
    cursor: pointer;

  }
  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
  }
  .btn1 {
    border: 1px solid #299200;
  }

  .btn1 > div {
    color: #299200 !important;
  }
  .el-pagination{
      display: flex;
      justify-content: flex-end;
  }
  .noData{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-items: center;
}
.noData img{
  width: 211px;
  height: 180px;
  margin-bottom: 20px;
}
.noData{
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #A8ADB9;
}
</style>



// WEBPACK FOOTER //
// src/views/console/components/AuthorizedApp.vue